<template>
  <div>
    <div class="title bolder underline mb-2">기관 선택:
      <add-btn-sm class="ml-4" @click="onAdd">기관추가</add-btn-sm>
    </div>
    <div v-for="(org, i) in orgs" :key="i" :value="org">
      <div v-if="active === org" class="bolder">
        <mdb-icon icon="check"  class="mr-2"/>
        {{org.name}}
        <mdb-btn class="p-0 m-0 ml-2" color="danger" icon="times" @click="onDeleteOrg(org)"/>
      </div>
      <div v-else class="ml-4 ">
        <span class="pointer" @click="onClick(org)">{{org.name}}</span>
        <mdb-btn class="p-0 m-0 ml-2" color="danger" icon="times" @click="onDeleteOrg(org)"/>
      </div>
    </div>
    <modal-dlg v-if="modal" icon="plus" title="기관 추가" :show="modal"  @close="onClose">
      <div class="px-3">
        <mdb-input label="기관명" v-model="newOrg.name"/>
        <mdb-input label="기관 구분명" v-model="newOrg.prefix"/>
      </div>
      <div class="text-center">
        <mdb-btn class="py-2" color="primary" @click="onSave">저장</mdb-btn>
        <mdb-btn class="py-2" @click="onClose">닫기</mdb-btn>
      </div>
    </modal-dlg>
  </div>
</template>
<script>
import { } from 'mdbvue';
import Org from '@/models/Org'
export default {
  name: 'AdminOrgTree',
  data: () => ({
    active: {},
    org: {},
    orgs: [],
    newOrg: {},
    modal: false
  }),
  methods: {
    onClick (org) {
      this.active = org
      this.$emit('input', org)
    },
    onAdd () {
      this.modal = true
      this.newOrg = {}
    },
    async onSave () {
      if (!this.newOrg.name) {
        return alert('기관명을 입력하세요')
      }
      this.org = await Org.create(this.newOrg).save()
      this.orgs.push(this.org)
      this.onClose()
    },
    async onDeleteOrg (org) {
      if (!confirm('삭제할까요')) return
      await org.delete()
      const ix = this.orgs.findIndex(o => o._id === org._id)
      if (ix !== -1) {
        this.org = undefined
        this.orgs.splice(ix, 1)
      }
    },
    onClose () {
      this.modal = false
      this.newOrg = {}
    }
  },
  async created () {
    this.orgs = await Org.list()
  }
}
</script>
